<script>
    import DashboardTileNavigationArrow from './DashboardTileNavigationArrow.vue';
    import ButtonNormal from '../buttons/ButtonNormal.vue';
    import axios from 'axios';
    import GroupService from '@/services/GroupService';
    import UserService from '@/services/UserService';
    import PhonenumberService from '@/services/PhonenumberService';
    import SorterService from '@/services/SorterService';
    import FaxUserService from '@/services/FaxUserService';
    import SupportUserService from '@/services/SupportUserService';
    import {URLS} from '@/services/Constants';
    import RadialProgressBar from 'vue-radial-progress';
    import CallsOverviewService from '@/services/CallsOverviewService';
    import Modal from '../shared/Modal.vue';
    import {TOGGLE_USER_LIMIT_FOR_DASHBOARD} from '@/store/mutation-types';
    import ConferenceService from '@/services/ConferenceService';
    import Badge from '../shared/Badge';
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'Dashboard',
        components: {
            DashboardTileNavigationArrow,
            ButtonNormal,
            Modal,
            RadialProgressBar,
            Badge
        },
        data() {
            return {
                fill: {
                    color: '#F59B00',
                },
                userList: [],
                groupList: [],
                callsLists: [],
                lastThreeGroupsList: [],
                groupsLoaded: false,
                blockAddingOfUsersBecauseOfUserLimit: false,
                isModalForUserLimitVisible: false,
                phonenumberList: [],
                phonenumbersCountInTotal: 0,
                phonenumbersAssignedCount: 0,
                isConferenceTileVisible: false,
                isConferenceConfigurationTileVisible: false,
                conferenceNumber: '',
                premiumFeatures: ['Fax', 'Mailboxansage', 'Adressbuch importieren', 'Hotline mit Sprachmenü', 'Tischtelefon', 'Geschäftszeitenregelung'],
                createdHotlineNumber: null
            };
        },
        created() {
            const self = this;

            UserService.getAllUsers().then(responseGetAllUsers => {
                self.userList = responseGetAllUsers.data;
                FaxUserService._removeFaxUserFromList(self.userList);
                SupportUserService._removeSupportUserFromList(self.userList);
            });
            CallsOverviewService.getCallsOverview()
                .then((responseCallsOverview) => {
                    self.callsLists = responseCallsOverview.data;

                    self.retrieveConferenceData();
                    if (self.callsLists) {
                        for (const entry of self.callsLists) {
                            entry.start = self.formatTimestamps(entry.start);
                        }
                    }
                });
            GroupService.getAllGroups().then(responseGetAllGroups => {
                self.groupList = responseGetAllGroups.data;
                self.getLastGroups();
            });
            PhonenumberService.getAllPhonenumbers().then(
                responseGetAllPhonenumbers => {
                    self.phonenumberList = responseGetAllPhonenumbers.data;
                    const result = PhonenumberService.getCountOfAllPhonenumbers(
                        self.phonenumberList,
                    );
                    this.extractHotlineNumber(self.phonenumberList);
                    self.phonenumbersCountInTotal = result.countOfAllPhonenumbers;
                    self.phonenumbersAssignedCount =
                        result.countOfAllAssignedPhonenumbers;
                },
            );
            if (self.$store.state.isLimitOf10UsersReached) {
                self.$store.commit(TOGGLE_USER_LIMIT_FOR_DASHBOARD, false);
                self.isModalForUserLimitVisible = true;
            }
        },
        methods: {
            ...mapActions(['getHotlineIVR']),
            retrieveConferenceData() {
                ConferenceService.getConfiguration().then(response => {
                    if (!response.data.externalNumberId && !this.callsLists) {
                        this.isConferenceTileVisible = true;
                    } else if (!this.callsLists && response.data.externalNumberId) {
                        this.isConferenceConfigurationTileVisible = true;
                        PhonenumberService.getPhonenumber(
                            response.data.externalNumberId,
                        ).then(result => {
                            this.conferenceNumber = PhonenumberService._createExternalPhonenumber(result.data).phonenumber;
                        });
                    }
                });
            },
            addUser() {
                if (this.blockAddingOfUsersBecauseOfUserLimit) {
                    this.isModalForUserLimitVisible = true;
                } else {
                    this.$router.push('/users');
                }
            },
            closeModalForUserLimit() {
                this.isModalForUserLimitVisible = false;
            },
            formatDuration(duration) {
                const durationArray = duration.split(':', 4);
                return durationArray[1] + ':' + durationArray[2] + ' Uhr';
            },
            formatTimestamps(timestamp) {
                const timestampArray = timestamp.split(' ', 2);
                const dateArray = timestampArray[0].split('-', 3);
                return dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0] + ' ' + timestampArray[1];
            },
            getLastUsers() {
                const result = this.userList.slice(0);
                SorterService._sortArrayOfStringsByParam(result, 'login');
                const numberOfLastUsers = Math.min(3, result.length);
                if (numberOfLastUsers > 0) {
                    this.latestUsersList = result.splice(
                        result.length - numberOfLastUsers,
                    );
                }
            },
            getLastGroups() {
                const result = this.groupList.slice(0);
                const numberOfGroups = Math.min(3, this.countGroups);
                if (numberOfGroups > 0) {
                    this.lastThreeGroupsList = result.splice(
                        result.length - numberOfGroups,
                    );
                    this.groupsLoaded = true;
                }
                const promises = [];
                const groupPhonenumbersArray = [];
                this.lastThreeGroupsList.forEach(group => {
                    promises.push(GroupService.getGroupById(group.id));
                });
                axios.all(promises).then(results => {
                    results.forEach(response => {
                        for (const entry of response.data.assignableNumbers) {
                            if (!entry.intern && entry.assigned) {
                                const phonenumber =
                                    '+' +
                                    entry.countryCode +
                                    ' ' +
                                    entry.localAreaCode +
                                    ' ' +
                                    entry.extension;
                                groupPhonenumbersArray.push({
                                    id: response.data.id,
                                    phonenumber,
                                });
                                break;
                            }
                        }
                    });
                    for (const entryLastThreeList of this.lastThreeGroupsList) {
                        for (const entryArray of groupPhonenumbersArray) {
                            if (entryLastThreeList.id === entryArray.id) {
                                entryLastThreeList.groupexternalnumber =
                                    entryArray.phonenumber;
                            }
                        }
                    }
                });
            },
            extractHotlineNumber(numbersList) {
                if (this.isPremium) {
                    let hotlineNumber;
                    this.getHotlineIVR().then( response => {
                        if (this.isHotlineCreated) {
                            numbersList.forEach(phoneNumber => {
                                if (phoneNumber.assignedModuleInstanceId) {
                                    hotlineNumber = phoneNumber;
                                }
                            });
                            const formatedHotlineNumber =
                                '+' +
                                hotlineNumber.nationalPrefix +
                                ' ' +
                                hotlineNumber.localPrefix +
                                ' ' +
                                hotlineNumber.number;
                            this.createdHotlineNumber = formatedHotlineNumber;
                        }
                    });
                }
            },
        },
        computed: {
            ...mapGetters({
                isHotlineCreated: 'isHotlineCreated',
                isPremium: 'isPremium',
                isTest: 'isTest'
            }),
            countUsers() {
                if (this.userList.length === 10) {
                    this.blockAddingOfUsersBecauseOfUserLimit = true;
                }
                return this.userList.length;
            },
            countGroups() {
                return this.groupList.length;
            },
            renderTariffMessage() {
                if (this.isPremium && this.isTest) {
                    return 'Du bist in der 30-tägigen Testphase';
                }
                if (!this.isPremium) {
                    return 'Dein Tarif: STARFACE UP Light';
                }
            }
        },
        watch: {
            '$store.state.isLimitOf10UsersReached'() {
                if (this.$store.state.isLimitOf10UsersReached) {
                    this.$store.commit(TOGGLE_USER_LIMIT_FOR_DASHBOARD, false);
                    this.isModalForUserLimitVisible = true;
                }
            },
        },
    };
</script>

<template>
    <div class="container">
        <div id="dashboard">
            <div class="tile users">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/outline_24.png" alt="Title Logo">
                        <span class="name">Benutzer</span>
                    </div>
                    <DashboardTileNavigationArrow route="/users/newUser"/>
                </div>
                <div class="content user-data">
                    <div class="number-of-user">
                        <radial-progress-bar :diameter="150" :completed-steps="countUsers" :total-steps="10"
                                             startColor="#F59B00" stopColor="#F59B00" innerStrokeColor="#F2F2F2"
                                             :strokeWidth="4">
                            <div><span class="counter">{{countUsers}}</span>/10</div>
                            <div>Benutzer</div>
                        </radial-progress-bar>
                    </div>
                </div>
                <ButtonNormal @onClick="$router.push('/users');" buttonTitle="zur Übersicht"
                              cssClass="btn btn-secondary"/>
            </div>
            <div class="tile phonenumber">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/numbers_24.png" alt="Title Logo">
                        <span class="name">Rufnummern</span>
                    </div>
                </div>
                <div class="content phonenumber-data">
                    <div class="number-of-phonenumbers">
                        <div class="count-wrapper"><span class="counter">{{phonenumbersAssignedCount}}</span> <span
                                class="total">/{{phonenumbersCountInTotal}}</span></div>
                        <div class="title">Rufnummern zugewiesen</div>
                    </div>
                </div>
                <ButtonNormal @onClick="$router.push('/phone-numbers')" buttonTitle="zur Übersicht"
                              cssClass="btn btn-secondary"/>
            </div>
            <div class="tile groups">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/teams_24.png" alt="Title Logo">
                        <span class="name">Gruppen & Hotline</span>
                    </div>
                    <DashboardTileNavigationArrow route="/groups/newGroup" v-if="lastThreeGroupsList.length"/>
                </div>
                <div class="content">
                    <template v-if="groupsLoaded">
                        <table class="table">
                            <tr>
                                <th class="table-header">Name</th>
                                <th class="table-header">Rufnummer</th>
                            </tr>
                            <template  v-if="lastThreeGroupsList.length > 0">
                                <tr v-for="entry in lastThreeGroupsList" :key="entry.id">
                                    <td>{{entry.groupname}}</td>
                                    <td>{{entry.groupexternalnumber}}</td>
                                </tr>
                                <tr v-if="isHotlineCreated">
                                    <td>HOTLINE</td>
                                    <td>{{createdHotlineNumber}}</td>
                                </tr>
                            </template>
                        </table>
                    </template>
                    <template v-else>
                        <p>
                            Du kannst mehrere Benutzer in Gruppen zusammenfassen, die dann alle unter einer Rufnummer
                            erreicht werden können.
                        </p>
                        <p>
                            <b>Leg jetzt Deine erste Gruppe an!</b>
                        </p>
                    </template>
                </div>
                <ButtonNormal @onClick="$router.push('/groups')" buttonTitle="zur Übersicht"
                              cssClass="btn btn-secondary"/>
            </div>

            <div class="tile conference" v-if="isConferenceConfigurationTileVisible && !isConferenceTileVisible && isPremium">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/conference_24.png" alt="Title Logo">
                        <span class="name">Konferenz</span>
                    </div>
                    <DashboardTileNavigationArrow route="/conference"/>
                </div>
                <div class="content conference-data conference_vertical-center">
                    <div class="wrapper">
                        <div class="title"> Aktuelle Konferenzrufnummer:</div>
                        <div class="number"> {{ conferenceNumber }}</div>
                    </div>
                </div>
                <ButtonNormal @onClick="$router.push('/conference')" buttonTitle="Konfigurieren"
                              cssClass="btn btn-secondary"/>
            </div>

            <div class="tile conference" v-if="isConferenceTileVisible && !isConferenceConfigurationTileVisible && isPremium">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/conference_24.png" alt="Title Logo">
                        <span class="name">Konferenz</span>
                    </div>
                </div>
                <div class="content conference-data conference_vertical-center">
                    <div class="wrapper">

                        <p>
                            Konferenzdienst noch nicht eingerichtet.
                        </p>
                        <p>
                            <b>Konfiguriere den Konferenzdienst jetzt!</b>
                        </p>
                    </div>
                </div>
                <ButtonNormal @onClick="$router.push('/conference')" buttonTitle="Konfigurieren"
                              cssClass="btn btn-secondary"/>
            </div>
            <div class="tile calls-overview" v-if="!isConferenceTileVisible && !isConferenceConfigurationTileVisible && isPremium">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/numbers_24.png" alt="Title Logo">
                        <span class="name">Gesprächsübersicht</span>
                    </div>
                </div>
                <div class="content conference-data">
                    <table class="table">
                        <tr>
                            <th class="table-header">Datum</th>
                            <th class="table-header">Rufnummer</th>
                        </tr>
                        <template v-if="callsLists && callsLists.length > 0" >
                            <tr v-for="call in callsLists.slice(0, 4)" :key="call.id">
                                <td>{{call.start}}</td>
                                <td>{{call.target}}</td>
                            </tr>
                        </template>
                    </table>
                </div>
                <ButtonNormal @onClick="$router.push('/calls-overview')" buttonTitle="zur Übersicht"
                              cssClass="btn btn-secondary"/>
            </div>
            <div class="tile premium-features" v-if="!isPremium">
                <div class="header">
                    <div class="title">
                        <img class="icon" src="@/assets/starface_icons_png/24/grey/tarif_24.png" alt="Title Logo">
                        <span class="name">Mehr Features gefällig?</span>
                    </div>
                    <Badge title="UP-Grade"/>
                </div>
                <div class="content premium-features-data">
                    <div class="wrapper">
                        <div class="feature" v-for="(feature, featureIndex) in premiumFeatures" :key="featureIndex">
                            <img class="icon" src="@/assets/starface_icons_png/24/orange/circle_checked.png" alt="Checked Circle"> 
                            <span>{{ feature }}</span>
                        </div>
                    </div>
                </div>
                <ButtonNormal @onClick="$router.push('/tariff')" buttonTitle="Tarif wechseln"
                              cssClass="btn btn-secondary"/>
            </div>
        </div>
        <div class="tariff-message">{{renderTariffMessage}}</div>
        <Modal v-show="isModalForUserLimitVisible" :isFooter="false" :isCross="true" :isRed="true"
               @close="closeModalForUserLimit">
            <template slot="body">
                <div class="reached-user-limit">
                    <p>Du hast die maximale Anzahl von 10 Benutzern erreicht. Natürlich geht mit STARFACE noch mehr!
                        Wenn Du mehr Benutzer einrichten möchtest und die ganze Funktionsvielfalt von
                        STARFACE-Telefonanlagen kennen lernen möchtest,
                        dann kontaktiere uns einfach!
                    </p>
                    <p>
                        <a href="tel:+49 721 981 991 00">
                            <img src="@/assets/starface_icons_png/16/orange/phone_16.png" alt="Call"/>
                            <b>+49 721 981 991 00</b> anrufen
                        </a>
                    </p>
                    <p>
                        <a href="mailto:up@starface.com">
                            <img src="@/assets/starface_icons_png/16/orange/mail_16.png" alt="Write"/>
                            <b>up@starface.com</b> schreiben
                        </a>
                    </p>
                </div>
            </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';

    #dashboard {
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr 24px 1fr;
        -ms-grid-rows: 1fr 24px 1fr;
        grid-row-gap: 24px;
        color: $text;
        font-size: 18px;

        .tile {
            height: 326px;
            grid-column: 1;
            padding: 24px;
            background-color: white;
            box-shadow: 0 10px 45px 0 $tile-shadow;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 16px;

                .title {
                    display: flex;
                    align-items: center;
                    float: left;
                }

                img {
                    height: 26px;
                    width: 26px;
                }

                .icon {
                    margin-right: 8px;
                }

                .name {
                    font-size: 28px;
                }
            }

            .content {
                min-height: 180px;
                flex: 1 auto;
            }

            button {
                align-self: flex-end;
            }

            td {
                padding: 6px 0;
            }
        }

        .users {
            grid-column: 1 / span 1;
            grid-row: 1;
            -ms-grid-column: 1;
            -ms-grid-row: 1;
            justify-content: space-between;

            .user-data {
                display: grid;
                grid-template-columns: 1fr;

                .number-of-user {
                    grid-column: 1 / span 1;
                    grid-row: 1;
                    padding: 16px;
                    font-size: 18px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .counter {
                        color: $orange;
                        font-size: 58px;
                    }
                }
            }
        }

        .phonenumber {
            -ms-grid-column: 3;
            -ms-grid-row: 1;

            .phonenumber-data {
                display: flex;
                justify-content: center;
                align-items: center;

                .number-of-phonenumbers {
                    grid-column: 2 / span 1;
                    grid-row: 1;
                    align-self: center;
                    padding: 16px;
                    display: flex;
                    flex-direction: column;

                    .count-wrapper {
                        align-self: center;

                        .counter {
                            color: $orange;
                            font-size: 60px;
                        }

                        .total {
                            font-size: 38px;
                        }
                    }

                    .title {
                        font-size: 14px;
                        text-align: center;
                        white-space: nowrap;
                    }
                }
            }
        }

        .groups {
            grid-column: 1;
            grid-row: 3;
            -ms-grid-column: 1;
            -ms-grid-row: 3;
        }

        .groups, .calls-overview {
            .table {
                border-spacing: 0;
                width: 100%;
                margin-bottom: 20px;

                .table-header {
                    color: white;
                    font-size: 18px;
                    font-weight: normal;
                    background-color: #818181;
                    padding: 6px 16px;
                    text-align: left;
                }

                td {
                    padding-left: 16px;
                    padding-right: 16px;
                }

                td:last-child {
                    font-weight: bold;
                }
            }
        }

        .conference, .calls-overview {
            grid-column: 2;
            grid-row: 2;
            -ms-grid-column: 2;
            -ms-grid-row: 2;

            .conference-data {
                display: flex;
                align-items: flex-start;
                justify-content: center;

                &.conference_vertical-center {
                    align-items: center;
                }

                .wrapper {
                    .title {
                        font-size: 18px;
                        font-weight: bold;
                    }

                    .number {
                        font-size: 32px;
                    }
                }
            }
        }

        .premium-features {
            grid-column: 2;
            grid-row: 2;
            -ms-grid-column: 2;
            -ms-grid-row: 2;
            .premium-features-data {
                .wrapper{
                    padding-top: 18px;
                    display: grid;
                    grid-template-columns: 50% 50%;
                    height: 130px;
                    .feature {
                        display: flex;
                        align-items: center;
                        span {
                            font-size: 14px;
                            padding-left: 10px;;
                        }
                    }
                }
            }
        }
        tr:nth-child(even) {
            background-color: $tr-background-grey;
        }
    }

    .tariff-message {
        text-align: center;
        margin-top: 30px;
    }

    .reached-user-limit {
        width: 864px;

        a {
            color: $orange;
            display: flex;
            align-items: center;

            img {
                margin-right: 15px;
            }

            b {
                padding-right: 8px;
            }
        }
    }

    @media only screen and (min-width: 600px) {
        #dashboard {
            grid-template-columns: 1fr 1fr;
            grid-column-gap: 24px;

            .phonenumber {
                grid-row: 1;
                grid-column: 2;
            }

            .groups {
                grid-row: 2;
                grid-column: 1;
            }
        }
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        #dashboard {
            grid-template-columns: 1fr;
            grid-column-gap: 0px;
            .users {
                grid-row: 1;
                grid-column: 1;
            }
            .phonenumber {
                grid-row: 2;
                grid-column: 1;
            }
            .groups {
                grid-row: 3;
                grid-column: 1;
            }
            .conference, .calls-overview {
                grid-row: 4;
                grid-column: 1;
            }
            .premium-features {
                grid-row: 4;
                grid-column: 1;
            }
        }
    }
</style>
